import { IEntity } from './entities/IEntity';
import { isObject } from '../../lib/typeGuards';
import { ISonURL } from '../IUrl';
import { PagePackStates } from './PagePackState';

export enum FileState {
  pending = 'pending',
  ready = 'ready',
}

export type FileItemForms = {
  delete?: any;
  edit?: any;
  move?: any;
};

// FileItems / Attachments from java
export interface IFileItem<Forms = FileItemForms> extends IEntity {
  url: string;
  fileName: string;
  fileExtension: string;
  fileLink?: boolean;
  fileSizeBytes: number;
  fileState: FileState;
  mimeType: string;
  packState?: PagePackStates;

  fileTitle?: string;
  editedBy?: ISonURL;
  editDate?: string;
  originalFileName?: string;
  forms?: Forms;
}

// FileItems / Attachments from solr, eg. on2-service-adapter
export interface IFileItemSearch {
  url: {
    name?: string;
    url: string;
  };
  fileName: string;
  fileExtension: string;
  fileSizeBytes: number;
  mimeType: string;

  fileTitle?: string;
  snippet?: string;
  archived?: boolean;
  archiveDate?: string;
  customFileName?: string;
}

/**
 * checking if a given object is of type IAttachment
 */
export function isFileItem(item: unknown): boolean {
  return isObject(item) && 'fileState' in item && 'mimeType' in item && 'fileExtension' in item;
}

/**
 * Convenience function to display the correct attribute
 */
export function getDisplayName(fileName: string, fileTitle?: string): string {
  return fileTitle || fileName;
}

/**
 * Display File Item with Title
 */
export function getDisplayNameByFileItem(item: IFileItem): string {
  const { fileTitle, fileName } = item;
  return getDisplayName(fileName, fileTitle);
}
